import React from "react";

import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase-config";

const DeleteTodo = () => {
  const navigate = useNavigate();
  const todoSelector = useSelector((state) => state.todo.todos);
  const { id } = useParams();

  const delItem = () => {
    console.log("deleted");
    const filtered = todoSelector.filter((item) => {
      return item.id === id;
    })[0];
    const mydoc = doc(db, "todos", id);
    deleteDoc(mydoc, filtered);
    console.log("deleted");
    navigate("/");
  };

  return (
    <InputDivs>
      <ButtonGroups>
        <DelBtn className="del_btn" onClick={delItem}>
          <DeleteIcon />
        </DelBtn>
        <CancelBtn onClick={() => navigate("/")} className="cancel_btn">
          Cancel
          <CancelIcon className="cancel_icon" />
        </CancelBtn>
      </ButtonGroups>
    </InputDivs>
  );
};

export default DeleteTodo;

const InputDivs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 35px;
`;

const ButtonGroups = styled.div`
  display: flex;
  justify-content: center;
  border: 1px solid;
  width: 300px;

  & > button {
    flex: 1;
    margin: 5px;
    border: none;
    padding: 10px 5px;
    background-color: #cfcfcf;
    cursor: pointer;
    font-size: 18px;
  }
`;

const CancelBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  & > .cancel_icon {
    margin: 0px 10px;
    &:hover {
      color: green;
    }
  }
`;

const DelBtn = styled(CancelBtn)`
  &:hover {
    color: red;
  }
`;
